exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid {\n  height: 100%; }\n\n.image {\n  margin-top: -100px; }\n\n.column {\n  max-width: 450px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/app/components/public/login/login.component.scss
// module id = ../../../../../src/app/components/public/login/login.component.scss
// module chunks = main